import React from 'react'

const productTags = [
  'Antena GPS',
  'Cabos',
  'Chicotes',
  'Ventosas',
  'Monitores',
  'Sensores',
  'E muito mais...'
]

const Products = () => {
  return (
    <section id="produtos">
      <div className="section-title">
        <h2>Vendas de Componentes</h2>
        <p>Peças de reposição e acessórios com garantia de qualidade</p>
      </div>

      <div className="products-list">
        {productTags.map((tag, index) => (
          <span className="product-tag" key={index}>
            {tag}
          </span>
        ))}
      </div>

      <a href="https://wa.me/5567981414278" className="btn">
        Clique aqui para comprar
      </a>
    </section>
  )
}

export default Products
